import React, { Component } from 'react';
import {
    Route,
    BrowserRouter as Router,
    Routes,
    Navigate
} from "react-router-dom";
import SearchProducts from './search-products.jsx';
import SearchDocuments from './search-documents.jsx';
import { getUrlParams } from '../../../utils/';
import SearchInput from './search-input.jsx';
import SearchNav from './search-nav.jsx';
import SearchBlog from './search-blog.jsx';
import SearchVideos from './search-videos.jsx';
import SearchTerms from './search-terms.jsx';
import SearchPodcasts from './search-podcasts.jsx';
import SearchPages from './search-pages.jsx';
import { getSearchTerms } from '../../../apis/search';

class SearchMain extends Component {
    constructor(props) {
        super(props);

        this.state = {
            q: '',
            searchTerms: []
        }

        this.onSearchInput = this.onSearchInput.bind(this);
        this.searchInput = React.createRef();
    }

    componentDidMount() {
        const params = getUrlParams();
        this.getSearchTerms();

        this.setState({
            q: params.q
        });
    }

    getSearchTerms() {
        getSearchTerms()
            .then(data => {

                const parsedData = JSON.parse(data);
                this.setState({
                    searchTerms: parsedData
                });
            })
            .catch(err => {
                console.log(err);
            });
    }

    onSearchInput(e) {
        e.preventDefault();
        this.setState({
            q: this.searchInput.current.value
        });
    }

    onClickSearchTerm(e) {
        const target = e.target;

            this.setState({
            q: target.value
        });
    }

    render() {
        return (
            <div>

                <Router basename="/search">
                    <SearchInput q={this.state.q} onSubmit={this.onSearchInput} searchInput={this.searchInput} />
                    <SearchTerms searchTerms={this.state.searchTerms} clickTerm={this.onClickSearchTerm.bind(this)}/>
                    <SearchNav q={this.state.q} />
                    <Routes>
                        <Route path="/products" element={<SearchProducts q={this.state.q} />} />
                        <Route path="/documents" element={<SearchDocuments q={this.state.q} />} />
                        <Route path="/inspiration" element={<SearchBlog q={this.state.q} />} />
                        <Route path="/videos" element={<SearchVideos q={this.state.q} />} />
                        <Route path="/pages" element={<SearchPages q={this.state.q} />} />
                        <Route path="/" element={<Navigate to="/products" />} />
                    </Routes>
                </Router>

            </div>
        );
    }

}


SearchMain.defaultProps = {
    q: ''
};

export default SearchMain;

